import script from "./box.vue?vue&type=script&setup=true&lang=js"
export * from "./box.vue?vue&type=script&setup=true&lang=js"

import "./box.vue?vue&type=style&index=0&id=c2e3098a&scoped=true&lang=sass"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c2e3098a"]])

export default __exports__